import { jsx as _jsx } from "react/jsx-runtime";
export const SoundCloudEmbed = ({ contentInfo }) => {
    const iframeUrl = new URL('https://w.soundcloud.com/player/');
    const urlSearchParameters = new URLSearchParams({
        auto_play: 'false',
        color: '#ff5500',
        hide_related: 'true',
        show_comments: 'false',
        show_reposts: 'false',
        show_teaser: 'true',
        show_user: 'true',
        url: contentInfo.url,
        visual: 'true',
    });
    iframeUrl.search = urlSearchParameters.toString();
    return (_jsx("iframe", { loading: "lazy", src: iframeUrl.toString(), style: {
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            width: '100%',
        } }));
};
//# sourceMappingURL=SoundCloudEmbed.js.map